import Button from "components/Buttons/ThemeButton";
import styled, { CSSProperties } from "styled-components";

export const Container = styled.div<{ backgroundImageUrl?: string }>`
	width: 100%;
	padding: 0px;
	position: relative;
	display: flex;
	justify-content: center;
	overflow: hidden;
	border-radius: 18px;
	//font-size: 4dvw;
	font-size: clamp(1px, 4dvw, 26px);
	height: 27.1em;

	background-image: url(${(props) => props.backgroundImageUrl});
	background-size: 100% 100%;

	@media (min-width: 650px) {
		//font-size: 1.55dvw;
		font-size: clamp(1px, 1.55dvw, 20px);
		height: 22em;
	}
`;

export const Background = styled.div<{ imageUrl?: string }>`
	content: url(${(props) => props.imageUrl});
	width: 100%;
	height: 100%;
`;

export const OfferItem = styled.div`
	position: relative;
	grid-template-rows: auto;
	background-color: rgba(0, 0, 0, 0.25);
	border-radius: 12px;
	padding: 0.5em 0.5em;
	gap: 0.5rem;
	box-sizing: border-box;
	height: auto;
	z-index: 999;
	align-content: stretch;
	width: 100%;
`;

export const LoyaltyContainer = styled.div`
	position: relative;
	background-color: rgba(0, 0, 0, 0.25);
	border-radius: 12px;
	//padding: 0.5em 0.5em;
	gap: 0.5rem;

	box-sizing: border-box;
	width: 100%;
	height: auto;
	min-height: 3.6em;
	z-index: 999;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const DataContainer = styled.div`
	position: absolute;
	width: 93%;
	bottom: 5%;
	height: 50%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;

	@media (min-width: 650px) {
		font-size: 1.1em;
		bottom: 10%;
		right: 4%;
		height: 68%;
		width: 40%;
		justify-content: space-between;
		align-items: right;
	}
`;

export const Items = styled.div`
	justify-content: center;
	align-items: center;
	display: flex;
	flex-wrap: nowrap;
	height: 6em;

	@media (min-width: 650px) {
		height: 7em;
	}
`;

export const RewardItem = styled.div<{ width: string }>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-basis: ${(props) => props.width};
	box-sizing: border-box;
`;

export const RewardAmountContainer = styled.div``;

export const ItemImage = styled.img`
	object-fit: contain;
	justify-self: center;
	align-self: center;

	width: 100%;
	height: 3em;

	&.crown {
		width: 2.5em;
		height: 2.5em;
	}
`;

export const Text = styled.div`
	text-shadow: 1px 0 #000, -1px 0 #000, 0 1px #000, 0 -1px #000, 1px 1px #000,
		-1px -1px #000, 1px -1px #000, -1px 1px #000, 1px 2px 2px rgba(0, 0, 0, 0.5);
	color: #fff;
	font-weight: 700;
`;

export const RewardAmount = styled(Text)`
	font-size: 0.9em;
`;

export const SubTitle = styled(Text)`
	width: 100%;
	margin-left: 1.5em;
	font-size: 0.9em;
	line-height: 2.1em;

	@media (min-width: 650px) {
		display: flex;
		align-items: end;
		height: 2em;
		line-height: 1.5em;
	}
`;

export const LoyaltyPoints = styled(Text)`
	font-size: 1em;
`;

export const CrossOutContainer = styled("div")`
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	background-color: #efececff;
	width: fit-content;
	border-radius: 15px;
	padding: 0.2em 1.2em;
`;

export const CrossOutValue = styled("div")`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.9em;
	color: #eb5757;
	font-weight: 700;
	gap: 0.3em;

	&::after {
		content: "";
		position: absolute;
		width: 110%;
		border-bottom: 0.15em solid #eb5757;
		top: 55%;
		//left: 0;
		transform: translateY(-50%);
	}
`;

export const PoisBounty = styled(Text)`
	font-size: 0.9em;
	color: #fbbd05;
	font-weight: 700;
`;

export const ButtonContainer = styled("div")`
	width: 100%;
	display: flex;
	justify-content: center;
	flex-direction: column;
	gap: 0.4em;
	align-items: center;
`;

export const CustomButton = styled(Button)`
	width: 100%;
	//margin-top: 0.5em;
	height: 3.1em;
	font-size: 1em;

	@media (min-width: 650px) {
		width: 75%;
		height: 2.8em;
	}
`;

export const InfoButton = styled.img`
	position: absolute;
	top: 10%;
	right: 2%;
	z-index: 2;
	width: 1.5em;
	height: 1.5em;
	cursor: pointer;

	&.rebate-info-button {
		font-size: 1.1em;
		top: 10%;
		right: 4%;
		@media (min-width: 650px) {
			font-size: 1.2em;
			top: 38%;
			right: 66%;
		}
	}
`;

export const bannerStyle: CSSProperties = {
	height: "2.2em",
	display: "flex",
	alignItems: "center"
};

export const textStyle: CSSProperties = {
	lineHeight: "2.2em",
	fontSize: "1em"
};
